import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { User } from "../lib/api";
import { toast } from "sonner";

export function useUser() {
  const navigate = useNavigate();

  const getCookie = (name: string): string | null => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop()?.split(";").shift() || null;
    return null;
  };

  const [user, setUser] = useState<User | null>(() => {
    const userCookie = getCookie("user");
    if (userCookie) {
      try {
        return JSON.parse(decodeURIComponent(userCookie));
      } catch (error) {
        toast.error("Failed to parse user cookie");
        return null;
      }
    }
    return null;
  });

  const logout = () => {
    document.cookie = "accessToken=; path=/; max-age=0; SameSite=Strict";
    document.cookie = "user=; path=/; max-age=0; SameSite=Strict";
    setUser(null);
    navigate("/login");
  };

  const isAuthenticated = !!getCookie("accessToken");

  return { user, logout, isAuthenticated };
}
